import { useState } from "react";
import styledComponents from "styled-components";

const Style = styledComponents.div`

width:${(prop) => prop.Width};
height:${(prop) => prop.Height};

img{
  object-fit:${(prop) =>
    prop.$objectFit ? prop.$objectFit : "cover"} !important;
  filter: ${(prop) => (prop.$brightness ? "brightness(0.5)" : "none")};
}
 span{
  height:100% !important;
}
@media (max-width: 786px) {
  height:${(prop) => (prop.Height2 ? prop.Height2 : "auto")};
 width: auto !important;
}

`;

export const ImageFrame = ({
  width,
  height,
  height2,
  ImageComp,
  objectFit,
  brightness,
  imgClass,
}) => {
  return (
    <Style
      Height={height}
      Height2={height2}
      Width={width}
      $objectFit={objectFit}
      $brightness={brightness}
    >
      {ImageComp}
    </Style>
  );
};

export const ImageLoaderUpdate = ({
  src,
  imageWrapperClassName,
  width,
  height,
  imgClass,
  ...props
}) => {
  const defaultImage = "";
  const [isImageLoading, setImageLoading] = useState(src ? src : defaultImage);

  const imageStyle = {
    width: width ? `${width}px` : "100%",
    height: height ? `${height}px` : "100%",
    objectFit: "cover",
  };

  return (
    <div className={`${imageWrapperClassName} `}>
      <img
        src={isImageLoading || src}
        alt=""
        className={`${imgClass || ""}`}
        style={imageStyle}
        {...props}
        onLoad={(e) => {
          setTimeout(() => {}, 3000);
        }}
        onError={(e) => setImageLoading("/loading.jpg")}
      />
    </div>
  );
};
